function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Iframe, Observer, createQueryString, parseUrl } from '@sie/web-common-utils';
var ADJUST_PRIVACY_SETTINGS = '011';
/**
 * Parts extracted from https://github.snei.sony.com/SNEI/hawklet-events/blob/master/tests/dummy/app/lib/cosmic-cube-reporter.js
 *
 * Responsible for opening cosmic cube in an iframe and listening for events.
 * @see  {@link https://confluence.sie.sony.com/display/COS/Cosmic+Cube+API+Spec}
 */

/**
 * cosmicCubeReporter.on('open', () => {
 *    // add scroll-lock classes
 *    const scrollPosition = document.body.scrollTop;
 * });
 * cosmicCubeReporter.on('load', () => {
    this._restoreScrollPosition(scrollPosition);
  });
 */

var CosmicCubeReporter = /*#__PURE__*/function () {
  function CosmicCubeReporter() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$loader = _ref.loader,
        loader = _ref$loader === void 0 ? new Iframe() : _ref$loader,
        _ref$url = _ref.url,
        url = _ref$url === void 0 ? 'https://onlinesafetyreport.{envExceptNp}.playstation.com/cc/web/release/' : _ref$url,
        _ref$npEnvironment = _ref.npEnvironment,
        npEnvironment = _ref$npEnvironment === void 0 ? 'e1-np' : _ref$npEnvironment,
        locale = _ref.locale,
        _ref$isDryRun = _ref.isDryRun,
        isDryRun = _ref$isDryRun === void 0 ? true : _ref$isDryRun;

    _classCallCheck(this, CosmicCubeReporter);

    _defineProperty(this, "_handleMessage", function (message) {
      // Verify message origin is trusted
      if (message.origin !== _this._trustedOrigin) return;
      var data = message && message.data || {}; // Data can either return as an object or JSON string. Parse if JSON.

      if (typeof data === 'string') {
        try {
          data = JSON.parse(message.data);
        } catch (error) {
          throw new Error("Grief report data found to have invalid JSON:\n ".concat(error));
        }
      }

      var _data = data,
          event = _data.event;

      switch (event) {
        case 'close':
          _this._observer.emit('close', _this._formatCloseEvent(data));

          _this.close();

          break;

        case 'error':
          _this._observer.emit('error', data);

          _this.close();

          break;

        default:
          _this._observer.emit('data', data);

      }
    });

    _defineProperty(this, "_formatCloseEvent", function (messageEventData) {
      // TODO: Possibly need to do something special for 999 (fatal error).
      var target = messageEventData.target,
          targetAccountId = messageEventData.target_account_id,
          unfriend = messageEventData.unfriend,
          block = messageEventData.block,
          unfollow = messageEventData.unfollow,
          leaveGroup = messageEventData.leave_group,
          code = messageEventData.code;
      var action;

      if (block) {
        action = 'block';
      } else if (unfriend) {
        action = 'unfriend';
      } else if (unfollow) {
        action = 'unfollow';
      } else if (leaveGroup) {
        action = 'leaveGroup';
      } else if (code && code === ADJUST_PRIVACY_SETTINGS) {
        action = 'adjustPrivacySettings';
      }

      return {
        action: action,
        target: {
          onlineId: target,
          accountId: targetAccountId
        }
      };
    });

    this._observer = new Observer({
      name: 'CosmicCubeReporter',
      events: ['open', 'load', 'data', 'close', 'error']
    });
    this._iframe = loader;
    this._locale = locale;
    this._isDryRun = isDryRun;
    this._url = url.replace('{envExceptNp}.', npEnvironment === 'np' ? '' : "".concat(npEnvironment, "."));
    this._trustedOrigin = parseUrl(this._url).origin;
  }

  _createClass(CosmicCubeReporter, [{
    key: "_formatUrl",
    value: function _formatUrl(targets) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$flow = _ref2.flow,
          flow = _ref2$flow === void 0 ? 'standard' : _ref2$flow;

      var queryParams = {
        dry_run: this._isDryRun,
        locale: this._locale,
        flow: flow,
        parent_origin: window.location.origin,
        targets: JSON.stringify(flow === 'standard' ? {
          items: targets
        } : targets)
      };
      var queryString = createQueryString(queryParams, {
        stringifyArrays: true
      });
      return this._url + queryString;
    }
    /**
     * Appends an iframe to the document's body, constructs queryParams,
     * and returns promise to be resolved on report closure.
     *
     * @param {Object} item - The report model.
     * @param {Object} item.reportableIds - Reportable ids associated with the report type to send.
     * @param {Array.<string>} item.reportableFields - Reportable fields of the item to report.
     * @param {Object=} options = {} - Options that modify the comsmic cube application.
     *                                 see cosmic cube api docs for more information.
     */

  }, {
    key: "beginReport",
    value: function beginReport(item) {
      var _this2 = this;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          parentEl = _ref3.parentEl,
          options = _objectWithoutProperties(_ref3, ["parentEl"]);

      var src = this._formatUrl(item, options);

      this._observer.emit('open', {
        src: src
      });

      this._iframe.make({
        src: src,
        onMessage: this._handleMessage,
        onLoad: function onLoad(load) {
          return _this2._observer.emit('load', load);
        },
        onError: function onError(error) {
          return _this2._observer.emit('error', error);
        },
        parentEl: parentEl
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.cancel();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._isClosed = true;

      this._iframe.destroy();

      this.off();
    }
  }, {
    key: "on",
    value: function on(eventName, cb) {
      return this._observer.on(eventName, cb);
    }
  }, {
    key: "off",
    value: function off(eventName) {
      this._observer.off(eventName);
    }
  }]);

  return CosmicCubeReporter;
}();

export default CosmicCubeReporter;